import AjaxService from '../services/ajax-service';

export const subscribe = (associationType, associationId) => {
    return AjaxService({
        method: 'post',
        url: `${associationType}/${associationId}/subscribe`
    }).then(response => response.data.data);
}

export const unsubscribe = (associationType, associationId) => {
    return AjaxService({
        method: 'delete',
        url: `${associationType}/${associationId}/subscribe`
    }).then(response => response.data.data);
}
